import { DEFAULT_VALUES_ENDPOINT } from './const'
import { pisaClient } from './pisaClient'

export type EntityDefaultValues = Record<string, unknown>

export type DefaultValuesPayload = Record<string, unknown> & {
  entityName: string
  data?: Record<string, unknown>
}

async function createDefaultValues(
  payload: DefaultValuesPayload,
): Promise<EntityDefaultValues> {
  const client = await pisaClient(DEFAULT_VALUES_ENDPOINT)
  const result = await client.post('', { data: payload })

  if (!result || typeof result !== 'object' || Array.isArray(result)) {
    throw new Error(
      `Unexpected default values response for "${payload.entityName}": ${String(result)}`,
    )
  }

  return result as EntityDefaultValues
}

export const Default = {
  create: createDefaultValues,
}

/**
 * Fetches backend-provided default values for a record.
 * Uses `POST /default` with `{ entityName, data? }`.
 */
export async function fetchDefaultValues(
  entityName: string,
  data?: Record<string, unknown>,
): Promise<EntityDefaultValues> {
  const defaults = await Default.create({
    entityName,
    ...(data ? { data } : {}),
  })
  return defaults
}
